module.exports = __webpack_public_path__ + "img/shop-photo12.c7303041.jpg";